<template>
  <base-dialog width="560px" show-close :visible.sync="visible" class="total-dialog">
    <template v-slot:header>{{ totalOperationMap[operation] }}</template>
    <el-form ref="form" :model="totalInfo" label-width="100px" :rules="rules" label-position="left">
      <el-form-item label="总计名称" prop="name">
        <el-input v-model="totalInfo.name"></el-input>
      </el-form-item>
      <el-form-item label="汇总维度" prop="axisId" v-if="totalInfo.group === 'kindColumnTotalList'">
        <el-tooltip content="不可设置最后一个维度" placement="bottom">
          <i class="el-icon-info info"></i>
        </el-tooltip>
        <normal-select
          :select-list="axisList"
          :selected-item.sync="totalInfo.axisId"
          filterable
        ></normal-select>
      </el-form-item>
      <el-form-item label="总计函数" prop="method">
        <normal-select
          :select-list="totalMethodList"
          :selected-item.sync="totalInfo.method"
          filterable
        ></normal-select>
      </el-form-item>
      <el-form-item label="数据格式" prop="unit">
        <normal-select
          :select-list="dataFormatList"
          :selected-item.sync="totalInfo.unit"
          filterable
        ></normal-select>
        <el-checkbox class="thousands" v-model="totalInfo.showThousands">千分位</el-checkbox>
      </el-form-item>
      <el-form-item label="数据范围" prop="range" v-if="totalInfo.group === 'columnTotalList'">
        <normal-select
          :select-list="rangeList"
          :selected-item.sync="totalInfo.range"
          filterable
        ></normal-select>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import {
  totalMethodList,
  totalOperationMap,
  dataFormatList,
  rangeList
} from "@/views/Backend/Admin/Statistics/chartEdit/static"

export default {
  name: "total-dialog",
  components: { NormalSelect, BaseDialog, BaseButton },
  props: {
    operation: String,
    total: Object,
    kind: String,
    dimensions: Array
  },
  data() {
    return {
      totalOperationMap,
      totalMethodList,
      dataFormatList,
      rangeList,
      visible: false,
      totalInfo: {},
      rules: {
        name: [{ required: true, message: "请输入总计名称", trigger: "blur" }],
        axisId: [{ required: true, message: "请选择汇总维度", trigger: "change" }],
        method: [{ required: true, message: "请选择总计函数", trigger: "change" }]
      }
    }
  },
  computed: {
    axisList() {
      let list =
        this.dimensions
          ?.filter(dimension => !dimension.hidden && dimension.type !== "COLUMN")
          .map(dimension => ({ label: dimension.name, value: dimension.id })) || []
      return list.length > 0 ? list.slice(0, list.length - 1) : list
    }
  },
  methods: {
    open() {
      this.totalInfo = this.total
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.$emit("submit", this.totalInfo)
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.total-dialog {
  .el-select {
    width: 100%;
  }
  .info {
    top: 13px;
    position: absolute;
    left: -30px;
  }
  .thousands {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
  }
}
</style>
